export class ClickAndHold {
  private target: HTMLElement;
  private callback: Function;
  private onEndCallback: Function;
  private holdTime = 0;

  private isActivelyHeld: boolean = false;
  private activeHoldTimeout: NodeJS.Timeout | null = null;

  /**
   * @param {HTMLElement} target The element to listen for clicks on
   * @param {function} callback The function to call when the element is clicked and held
   * @param {function} onEndCallback The function to call when the element is released
   * @param {number} holdTime The amount of time to hold the element before calling the callback
   *
   */
  constructor(
    target: HTMLElement,
    callback: Function = () => {},
    onEndCallback: Function = () => {},
    holdTime: number = 500
  ) {
    this.target = target;
    this.callback = callback;
    this.onEndCallback = onEndCallback;
    this.holdTime = holdTime;

    const START_EVENTS = ["mousedown", "touchstart"];
    const END_EVENTS = [
      "mouseup",
      "mouseleave",
      "mouseout",
      "touchend",
      "touchcancel",
    ];

    START_EVENTS.forEach((event) => {
      this.target.addEventListener(event, this._onHoldStart.bind(this));
    });

    END_EVENTS.forEach((event) => {
      this.target.addEventListener(event, this._onHoldEnd.bind(this));
    });
  }

  private _onHoldStart() {
    this.activeHoldTimeout = setTimeout(() => {
      this.isActivelyHeld = true;
      this.callback();
    }, this.holdTime);
  }

  private _onHoldEnd() {
    if (this.activeHoldTimeout) {
      clearTimeout(this.activeHoldTimeout);
    }

    if (this.isActivelyHeld) {
      this.onEndCallback();
      this.isActivelyHeld = false;
      return;
    }
  }
}

export default ClickAndHold;
